import { sendAnalytics } from '@audio-network/analytics'
import {
	Header as HeaderComponent,
	LogoLink,
} from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React from 'react'

import DesktopNavBar from './DesktopNavBar/DesktopNavBar'
import styles from './Header.module.css'
import HeaderActions from './HeaderActions/HeaderActions'
import MobileMenu from './MobileMenu/MobileMenu'

const Header = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<HeaderComponent
			className={styles.header}
			data-testid="music-app-header"
			id="music-app-header"
		>
			<MobileMenu />
			<LogoLink
				href="/"
				aria-label={t('go-to-dashboard')}
				className={styles.mobileLogoLink}
				onClick={() => handleClick('Logo')}
			/>
			<DesktopNavBar />
			<HeaderActions />
		</HeaderComponent>
	)
}

export default Header
